import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import App from './App';
import store from './store/store';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom'
import { loadTheme } from '@fluentui/react';
import { Providers, ProviderState } from '@microsoft/mgt-react';
import { scope_access_as_user } from './features/Auth/authConfig';
import { getDepartmentFromDisplayName, getDivisionFromDepartment, removeAliasDomain } from './utils/converter';
import { ICustomerVisit } from './features/Auth/types';
import { addSignInLog } from './features/Auth/services';
import Helper from './core/libraries/Helper';
import { Msal2Provider } from '@microsoft/mgt-msal2-provider';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

const initStore = store();

// Define a custom theme with a global font
const customTheme = {
  fonts: {
    small: {
      fontFamily: "BoschFont",
    },
    medium: {
      fontFamily: "BoschFont",
    },
    large: {
      fontFamily: "BoschFont",
    },
    xLarge: {
      fontFamily: "BoschFont",
    },
  },
};

// Apply the custom theme globally
loadTheme(customTheme);

Providers.globalProvider = new Msal2Provider({
  clientId: `${process.env.REACT_APP_AAD_CLIENT_ID!}`,
  scopes: ["GroupMember.Read.All", "User.ReadBasic.All", scope_access_as_user],
  authority: `https://login.microsoftonline.com/0ae51e19-07c8-4e4b-bb6d-648ee58410f4`,
  redirectUri: process.env.REACT_APP_REDIRECT_URI,
  isMultiAccountDisabled: false,
  isIncrementalConsentDisabled: true,
});

Providers.globalProvider.onStateChanged(() => {
  if (Providers.globalProvider.state !== ProviderState.SignedIn) return;

  const user = Providers.globalProvider.getActiveAccount?.();
  if (!user) return;

  const cachedToken = Helper.getAccessTokenInLocalStorage(scope_access_as_user, user.id);
  const accessTokenCachedTime = localStorage.getItem("accessTokenCachedTime");

  if (!cachedToken) return;

  // Only proceed if no cachedTime or cachedAt changed
  if (!accessTokenCachedTime || cachedToken.cachedAt !== accessTokenCachedTime) {
    localStorage.setItem("accessTokenCachedTime", cachedToken.cachedAt);

    const dep = getDepartmentFromDisplayName(user.name ?? "");
    const customerVisit: ICustomerVisit = {
      peopleId: removeAliasDomain(user.mail ?? ""),
      department: dep,
      division: getDivisionFromDepartment(dep),
      visitDateTime: new Date(Number(cachedToken.cachedAt) * 1000).toISOString(),
    };

    addSignInLog(customerVisit);
  }
});

root.render(
  <Router>
    <Provider store={initStore}>
      <App />
    </Provider>
  </Router>
);

reportWebVitals();
